import type { RefObject, ChangeEvent, Dispatch, SetStateAction, KeyboardEvent } from 'react'

import { useCallback, useEffect } from 'react'

const PADDING = 2

interface TextInputProps {
  value: string
  setSending: Dispatch<SetStateAction<boolean>>
  textInputRef: RefObject<HTMLTextAreaElement> | undefined
  onKeyPress: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
  onKeyUp: (e: KeyboardEvent<HTMLTextAreaElement>) => void
  placeholder: string
  actions?: {
    left?: JSX.Element[]
    right?: JSX.Element[]
  }
}

export function TextInput ({ value, setSending, textInputRef, onKeyPress, onKeyDown, onChange, onKeyUp, placeholder, actions }: TextInputProps): JSX.Element {
  const updateHeight = useCallback(() => {
    const textarea = textInputRef?.current
    if (textarea) {
      const previous = window.scrollY
      textarea.style.height = '0'
      textarea.style.height = `${textarea.scrollHeight + PADDING * 2}px`
      const current = window.scrollY
      if (previous !== current) {
        window.scrollY = previous
      }
    }
  }, [ textInputRef ])

  useEffect(() => {
    updateHeight()
  }, [ setSending, updateHeight, value ])

  return (
    <div className='nh-text-area-container'>
      <div className='actions'>
        {actions?.left?.map(act => act)}
      </div>
      <textarea
        value={value}
        onChange={e => {
          onChange(e)
          updateHeight()
        }}
        onKeyPress={(e) => onKeyPress(e)}
        onKeyDown={(e) => onKeyDown(e)}
        data-cy='input-textarea'
        onKeyUp={(e) => onKeyUp(e)}
        id='message-input'
        key='message'
        ref={textInputRef}
        placeholder={placeholder}
      />
      <div className='actions'>
        {actions?.right?.map(act => (
          act
        ))}
      </div>
    </div>
  )
}
